import React from 'react';
import { NeverShippedViewStore } from 'modules/order/stores';
import { NeverShippedTemplate } from 'themes/modules/order/pages';
import { setCurrentView } from 'core/utils';

@setCurrentView(
	(rootStore, componentProps) => new NeverShippedViewStore(rootStore, componentProps),
	'neverShippedViewStore'
)
class NeverShipped extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <NeverShippedTemplate {...this.props} />;
	}
}

export default NeverShipped;
